/* eslint-disable consistent-return */
/* eslint-disable prettier/prettier */

import { PageFooterWrapper } from '@usb-ui-tools/react-billpay-layout'
import { useEffect, useReducer, useRef, useState, useContext } from 'react'
import Loader from '../../../components/spinner'
import { BASE_PATH, googleAPIkey } from '../../../config/connections'
import routerpath from '../../../constants/routerpath'
import { appCache } from '../../../context/appCache'
import {
  payeeDashbord,
  searchedBillerDetails
  // selectedBillerDetails
} from '../../../graphql/cache/localCache'

import { getSessionStorageValue } from '../../../utils/sessionUtils'
import EditHeader from '../../../modules/payees/edit/header/edit-header'
import EditDetails from '../../../modules/payees/edit/details/details'
import RemoveBillPopup from '../../../modules/payees/edit/removeBill/removeBillPopup'
import { routeController } from '../../../router/routeController'
import { useMultilingualService } from '../../../service/multilingualService'
import { useDeleteBillService } from '../../../service/payees/deleteBill/deleteBill.service'
import { useEditService } from '../../../service/payees/edit.service'
import {
  getChannelId,
  isOLBOrIpadApp,
  isTuxApp
} from '../../../utils/browserutils'
import MobileBillPayLayout from '../../../modules/layout/MobileBillPayLayout'
import { errorMessageMappingForForm } from '../../../utils/errorMapping'
import handleAddBillError from '../../../utils/handleAddBillError'
import { PageviewTealiumEvent } from '../../../utils/tealiumwrapper'
import { PAGE_NAMES } from '../../../constants/tealiumData'
import { getAccountType, getBillerType } from '../../../utils/tealiumUtils'
import {
  configureNativeHeader,
  NativeInterfaceHandler
} from '../../../utils/nativeHandlers'
import ErrorComponent from '../error/index'
import './edit.scss'
import { LoaderContext } from '../../../context/LoaderContext'

/**
 * Edit Bill
 *
 *
 * @returns {HTMLElement}
 */

/**
 *
 * @returns This function will get the bill details from cache
 */
const getSelectedBills = () => {
  // deeplink
  const billpayDeepLinkNew = getSessionStorageValue('billpayDeepLinkNew')
  const {
    accountId = null,
    payeeData,
    isScheduled = false,
    isAutopayment = false,
    payeeExist = false,
    billerLogoUrl
  } = (billpayDeepLinkNew && JSON.parse(billpayDeepLinkNew)) || {}

  const selectedBills = {
    selectedBill: {
      payeeId: accountId,
      isScheduled,
      isAutopayment,
      aggregateBillPayee: payeeData,
      payeeExist,
      billerLogoUrl
    }
  }

  return selectedBills
}

const Edit = () => {
  const footerRef = useRef()
  const { selectedBill = {} } = getSelectedBills()
  const { showLoader = false, setShowLoader = null } = useContext(
    LoaderContext || {}
  )

  useEffect(() => {
    payeeDashbord({ isDashboard: false })
  }, [payeeDashbord])

  const {
    payeeId = null,
    isScheduled = false,
    isAutopayment = false,
    billerLogoUrl
  } = selectedBill
  const { aggregateBillPayee } = selectedBill
  const billPayPayee = aggregateBillPayee?.payee
  const { loadApi, loading, error, data } = useEditService()
  const {
    loadDeleteApi,
    deleteLoading,
    deleteCalled,
    deleteError,
    deleteData
  } = useDeleteBillService()
  const {
    isEbillActivated = false,
    ebillActivationStatus = null,
    isEbillEligible = false,
    isPayeeInternal = null
  } = aggregateBillPayee || {}

  const isEbill =
    isEbillEligible &&
    isEbillActivated &&
    ebillActivationStatus?.toLowerCase() === 'active'
  const isManagedBiller =
    aggregateBillPayee?.biller?.merchantAlias &&
    aggregateBillPayee?.biller?.merchantAlias !== null
  const isPersonBiller =
    aggregateBillPayee?.biller?.billerLogoUrl &&
    aggregateBillPayee?.biller?.billerLogoUrl.includes('DefaultPerson')
  /**
   *add your template area alignment here
   */

  useEffect(() => {
    window.scrollTo(0, 0)
    /* eslint-disable no-console */
    console.log('##### test: OBP Custom Event')
    const logger = (e) => console.log(e.detail.test, 'test###')
    document.addEventListener('onEditBill', logger)
    return () => document.removeEventListener('onEditBill', logger)
  }, [])
  const [payee, setPayee] = useState()

  searchedBillerDetails({
    billerName: 'Xcel Energy',
    initialNickName: 'Dev',
    initialAccountNumber: '1425362930',
    initialPhonenumber: '918-391-3090',
    initialAddress1: '1 Apple Park Way',
    initialAddress2: '',
    initialCity: 'Cupertino',
    initialState: 'CA',
    initialZipcode: '95014'
  })

  const [nickName, setNickName] = useState(
    billPayPayee?.nickName ? billPayPayee?.nickName : ''
  )
  const [name, setName] = useState(billPayPayee?.name ? billPayPayee?.name : '')

  const [openModal, setOpenModal] = useState(false)
  const [isSystemError, setSystemError] = useState(false)
  const [pageErrorMsg, setPageErrorMsg] = useState('')
  const [isFieldsValidationError, setFieldsValidationError] = useState(false)
  const [companyErrorCount, setCompanyErrorCount] = useState(0)
  const [personNameErrorCount, setPersonNameErrorCount] = useState(0)
  const [accountNumberErrorCount, setAccountNumberErrorCount] = useState(0)
  const [phoneNumberErrorCount, setPhoneNumberErrorCount] = useState(0)
  const [addressCollectionErrorCount, setAddressCollectionErrorCount] =
    useState({
      address1: 0,
      city: 0,
      state: 0,
      zipcode: 0
    })
  const [fieldLevelErrorData, setFieldLevelErrorData] = useState({})
  const companyRef = useRef()
  const personNameRef = useRef()
  const accountNumberRef = useRef()
  const phoneNumberRef = useRef()
  const addressCollectionRef = useRef()

  const ACTIONS = {
    UPDATE_COMPANY: 'update company',
    UPDATE_PERSON_NAME: 'update person name',
    UPDATE_ACCOUNT_NUMBER: 'update account number',
    UPDATE_PHONE_NUMBER: 'update phone number',
    UPDATE_ADDRESS_COLLECTION: 'update address collection',
    INIT_PAYEE: 'load payee'
  }
  const init = {
    accountNumber: {
      inputValue: billPayPayee?.payeeAccountInfo[0].maskedaccountNumber,
      errorCode: 0
    },
    phoneNumber: {
      inputValue: billPayPayee?.payeeContactPhoneNumber.includes('.')
        ? billPayPayee?.payeeContactPhoneNumber.replaceAll('.', '-')
        : billPayPayee?.payeeContactPhoneNumber.replace(
          /(\d{3})(\d{3})(\d{4})/,
          '$1-$2-$3'
        ),
      errorCode: 0
    },
    addressCollection: {
      address1: {
        inputValue: billPayPayee?.payeePostalAddress?.addressLine1,
        errorCode: 0
      },
      address2: {
        inputValue: billPayPayee?.payeePostalAddress?.addressLine2,
        errorCode: 0
      },
      city: {
        inputValue: billPayPayee?.payeePostalAddress?.city,
        errorCode: 0
      },
      state: {
        inputValue: billPayPayee?.payeePostalAddress?.state,
        errorCode: 0
      },
      postalCode: {
        inputValue: billPayPayee?.payeePostalAddress?.postalCode,
        errorCode: 0
      }
    }
  }
  const [formValues, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case ACTIONS.UPDATE_COMPANY:
        return { ...state, company: action.payload }
      case ACTIONS.UPDATE_PERSON_NAME:
        return { ...state, personName: action.payload }
      case ACTIONS.UPDATE_ACCOUNT_NUMBER:
        return { ...state, accountNumber: action.payload }
      case ACTIONS.UPDATE_PHONE_NUMBER:
        return { ...state, phoneNumber: action.payload }
      case ACTIONS.UPDATE_ADDRESS_COLLECTION:
        return { ...state, addressCollection: action.payload }
      case ACTIONS.INIT_PAYEE:
        return { ...state, ...action.payload }
      default:
        return ''
    }
  }, init)

  useEffect(() => {
    document.title = 'Edit bill'
    const reportingData = {
      isDelete: false,
      billerType: getBillerType(isPayeeInternal, isEbill),
      accountType: getAccountType(isPayeeInternal, isEbill)
    }
    PageviewTealiumEvent(PAGE_NAMES.EDIT_BILL, reportingData)
  }, [])

  useEffect(() => {
    if (payeeId) {
      const billpayDeepLink = {
        accountId: payeeId,
        navTo: routerpath.pages.billdetails,
        isPmMsg: true,
        successMsg: null,
        link: null,
        linkurl: null,
        fromPayee: isOLBOrIpadApp() ? '' : 'payee_management',
        siderrailLoad: 'ispayeeMangement',
        message: ''
      }
      appCache({ ...appCache(), Title: 'Edit bill' })
      configureNativeHeader(
        'findabilldashboard',
        true,
        BASE_PATH + routerpath.pages.edit,
        routerpath.pages.openbillpay,
        false,
        billpayDeepLink
      )
    }
  }, [payeeId])

  useEffect(() => {
    setPayee(billPayPayee)
    setNickName(billPayPayee?.nickName ? billPayPayee?.nickName : '')
    const updatePayee = {
      ...init
    }
    dispatch({ type: ACTIONS.INIT_PAYEE, payload: updatePayee })
  }, [])

  useEffect(() => {
    if (
      data?.updateBillpayPayee?.payee?.payeeStatus === 'ACTIVE' ||
      deleteData?.deleteBillpayPayee?.payeeStatus === 'INACTIVE'
    ) {
      let successMsg = null
      let navTo = null
      let fromPath = ''
      let isSiderail = ''
      let payeeIdVal = billPayPayee?.payeeId
      let type = ''
      if (data?.updateBillpayPayee?.payee?.payeeStatus === 'ACTIVE') {
        successMsg = 'Your changes have been saved.'
        navTo = isOLBOrIpadApp()
          ? routerpath.pages.home
          : routerpath.pages.billdetails
        fromPath = isOLBOrIpadApp() ? '' : 'payee_management'
        isSiderail = 'ispayeeMangement'
        type = 'edit'
      } else {
        payeeIdVal = ''
        successMsg = `You deleted ${billPayPayee?.displayName}.`
        navTo = routerpath.pages.home
        type = 'delete'
      }

      const sharedData = {
        currentPath: '/',
        channel: getChannelId(),
        AppFlow: 'OPENBILLPAY',
        AppError: false,
        ReturnURL: '',
        successMsg,
        payeeId: payeeIdVal,
        navTo,
        fromPayee: fromPath,
        siderrailLoad: isSiderail,
        type,
        data
      }
      routeController(sharedData)
    }
  }, [data, deleteData, deleteCalled, deleteLoading])
  const lang = useMultilingualService('addEditErrors')

  useEffect(() => {
    setShowLoader(false)
    handleAddBillError(
      error,
      lang,
      setSystemError,
      setFieldsValidationError,
      setPageErrorMsg,
      setFieldLevelErrorData
    )
  }, [error])

  useEffect(() => {
    setShowLoader(false)
  }, [deleteError])

  const openRemoveModal = () => {
    setOpenModal(true)
    NativeInterfaceHandler('PopUpHandler', true)
    setPageErrorMsg('')
    setFieldsValidationError(false)
    // tealium
    const reportingData = {
      isDelete: true,
      billerType: getBillerType(isPayeeInternal, isEbill),
      accountType: getAccountType(isPayeeInternal, isEbill)
    }
    PageviewTealiumEvent(PAGE_NAMES.EDIT_BILL, reportingData)
  }

  const handleStatusUpdate = (status) => {
    const { inputRef } = status

    switch (inputRef.current) {
      case companyRef.current:
        dispatch({ type: ACTIONS.UPDATE_COMPANY, payload: status })
        break
      case personNameRef.current:
        dispatch({ type: ACTIONS.UPDATE_PERSON_NAME, payload: status })
        break
      case accountNumberRef?.current:
        dispatch({ type: ACTIONS.UPDATE_ACCOUNT_NUMBER, payload: status })
        break
      case phoneNumberRef?.current:
        dispatch({ type: ACTIONS.UPDATE_PHONE_NUMBER, payload: status })
        break
      case addressCollectionRef?.current:
        dispatch({ type: ACTIONS.UPDATE_ADDRESS_COLLECTION, payload: status })
        break
      default:
        throw new Error(`A input with the name ${inputRef} does not exist`)
    }
  }

  const incrementErrorCounts = (errors) => {
    errors.forEach((err) => {
      switch (err.value) {
        case 'company':
          if (!isPersonBiller && companyErrorCount === 0) {
            setCompanyErrorCount(companyErrorCount + 1)
          }
          return
        case 'personName':
          if (isPersonBiller && personNameErrorCount === 0) {
            setPersonNameErrorCount(personNameErrorCount + 1)
          }
          return
        case 'accountNumber':
          setAccountNumberErrorCount(accountNumberErrorCount + 1)
          return
        case 'phoneNumber':
          setPhoneNumberErrorCount(phoneNumberErrorCount + 1)
          return
        case 'address1':
          setAddressCollectionErrorCount({
            ...addressCollectionErrorCount,
            address1: addressCollectionErrorCount.address1 + 1
          })
          return
        case 'city':
          setAddressCollectionErrorCount({
            ...addressCollectionErrorCount,
            city: addressCollectionErrorCount.city + 1
          })
          return
        case 'state':
          setAddressCollectionErrorCount({
            ...addressCollectionErrorCount,
            state: addressCollectionErrorCount.state + 1
          })
          return
        case 'zipcode':
          setAddressCollectionErrorCount({
            ...addressCollectionErrorCount,
            zipcode: addressCollectionErrorCount.zipcode + 1
          })
          return
        default:
          throw new Error(`No case exists for the value ${error}`)
      }
    })
  }

  const isAccountNumberInvalid =
    formValues?.accountNumber?.inputValue?.includes('*')

  const getNickName = () => {
    const existNickname = billPayPayee?.nickName || ''
    if (existNickname !== nickName) {
      return nickName
    }
  }
  const getPayeeName = () => {
    const existPayeeName = billPayPayee?.name || ''
    if (existPayeeName !== name) {
      return name
    }
  }

  const getAccountNumber = () => {
    if (!isAccountNumberInvalid) {
      const regrex = /.*/
      let accountNummodify = formValues.accountNumber.inputValue
      if (regrex.test(formValues.accountNumber.inputValue)) {
        accountNummodify = `${accountNummodify}`.replaceAll('•', '*')
      }

      if (init?.accountNumber?.inputValue !== accountNummodify) {
        return [
          {
            accountNumber: formValues.accountNumber.inputValue
          }
        ]
      }
    }
  }
  const getPhoneNumber = () => {
    if (init?.phoneNumber?.inputValue !== formValues.phoneNumber.inputValue) {
      return formValues.phoneNumber.inputValue
    }
  }
  const getPostalAddress = () => {
    const address2 = init?.addressCollection?.address2?.inputValue || ''
    const formaddrss2 = formValues.addressCollection.address2.inputValue || ''
    if (
      init?.addressCollection?.address1?.inputValue !==
        formValues.addressCollection.address1.inputValue ||
      address2 !== formaddrss2 ||
      init?.addressCollection?.city?.inputValue !==
        formValues.addressCollection.city.inputValue ||
      init?.addressCollection?.state?.inputValue !==
        formValues.addressCollection.state.inputValue ||
      init?.addressCollection?.postalCode?.inputValue !==
        formValues.addressCollection.postalCode.inputValue
    ) {
      return {
        addressLine1: formValues.addressCollection.address1.inputValue,
        addressLine2: formValues.addressCollection.address2.inputValue,
        city: formValues.addressCollection.city.inputValue,
        state: formValues.addressCollection.state.inputValue,
        postalCode: formValues.addressCollection.postalCode.inputValue
      }
    }
  }
  const updatedPayeeData = () => {
    if (isManagedBiller) {
      return {
        name: getPayeeName(),
        nickName: getNickName(),
        payeeId: billPayPayee?.payeeId,
        payeeContactPhoneNumber: getPhoneNumber(),
        payeeAccountInfo: getAccountNumber()
      }
    }
    return {
      name: getPayeeName(),
      nickName: getNickName(),
      payeeId: billPayPayee?.payeeId,
      payeeContactPhoneNumber: getPhoneNumber(),
      payeePostalAddress: getPostalAddress(),
      payeeAccountInfo: getAccountNumber()
    }
  }
  const cancelBillManually = () => {
    const payeeIdVal = billPayPayee?.payeeId
    const sharedData = {
      currentPath: '/',
      channel: getChannelId(),
      AppFlow: 'OPENBILLPAY',
      AppError: false,
      ReturnURL: '',
      successMsg: null,
      payeeId: payeeIdVal,
      navTo: isOLBOrIpadApp()
        ? routerpath.pages.home
        : routerpath.pages.billdetails,
      fromPayee: isOLBOrIpadApp() ? '' : 'payee_management',
      siderrailLoad: 'ispayeeMangement',
      data
    }
    routeController(sharedData)
  }

  const onSave = () => {
    const errors = []
    setPageErrorMsg('')
    setAddressCollectionErrorCount({
      address1: 0,
      city: 0,
      state: 0,
      zipcode: 0
    })
    Object.keys(formValues).forEach((value) => {
      const formValue = formValues[value]

      if (formValue === null) {
        const message = errorMessageMappingForForm({
          value,
          pageName: 'editBill'
        })
        errors.push({ value, message })
      }
      if (formValue && value === 'addressCollection') {
        if (formValue.address1.errorCode !== 0) {
          const message = errorMessageMappingForForm({
            value: 'address1',
            pageName: 'editBill'
          })
          errors.push({ value: 'address1', message })
        }
        if (formValue.city.errorCode !== 0) {
          const message = errorMessageMappingForForm({
            value: 'city',
            pageName: 'editBill'
          })
          errors.push({ value: 'city', message })
        }
        if (formValue.state.errorCode !== 0) {
          const message = errorMessageMappingForForm({
            value: 'state',
            pageName: 'editBill'
          })
          errors.push({ value: 'state', message })
        }
        if (formValue.postalCode.errorCode !== 0) {
          const message = errorMessageMappingForForm({
            value: 'zipcode',
            pageName: 'editBill'
          })
          errors.push({ value: 'zipcode', message })
        }
      } else if (formValue && formValue.errorCode) {
        const message = errorMessageMappingForForm({
          value,
          pageName: 'editBill'
        })
        errors.push({ value, message })
      }
    })
    incrementErrorCounts(errors)
    if (errors.length > 0) {
      setFieldsValidationError(true)
      if (errors.length === 1) {
        setPageErrorMsg(errors[0].message)
      }
    } else {
      setFieldsValidationError(false)
      console.log(init, formValues, 'updatePayee###')
      setShowLoader(true)
      const updtdNick = getNickName()
      const updtdPhone = getPhoneNumber()
      const updtdAccount = getAccountNumber()
      const updtdAddress = getPostalAddress()
      const updtPayeeName = getPayeeName()
      if (
        !!updtPayeeName ||
        !!updtdNick ||
        !!updtdPhone ||
        !!updtdAccount ||
        !!updtdAddress
      ) {
        loadApi({
          variables: {
            appName: 'BILLPAY',
            payeeUpdateRequest: { ...updatedPayeeData() }
          }
        })
      } else {
        cancelBillManually()
      }
    }
  }

  const handleFooterClick = (event, type) => {
    if (event && type === 'yes') {
      onSave()
    } else if (event && type === 'no') {
      cancelBillManually()
    } else if (event && type === 'cancel') {
      openRemoveModal()
    }
  }
  const closePopup = () => {
    setOpenModal(false)
    NativeInterfaceHandler('PopUpHandler', false)
  }
  const removeBill = () => {
    setOpenModal(false)
    NativeInterfaceHandler('PopUpHandler', false)
    setShowLoader(true)
    loadDeleteApi({
      variables: {
        appName: 'BILLPAY',
        payeeDeleteRequest: {
          payeeId: billPayPayee?.payeeId
        }
      }
    })
  }
  const { FOOTER } = useMultilingualService('editBill')

  if (showLoader) {
    return (
      <div
        data-testId="detailsloading"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100%'
        }}
      >
        <Loader />
      </div>
    )
  }
  return (
    <div className="edit-bill">
      {!(loading || deleteLoading || isSystemError || deleteError) && (
        <PageFooterWrapper
          id="edit-bill-footer"
          isOLBOrIpadApp={isOLBOrIpadApp}
          ref={footerRef}
          showRemoveButtonAloneInMobile={!isScheduled && !isAutopayment}
          contentBelowButton={
            isOLBOrIpadApp() ? '' : <div style={{ marginBottom: '40px' }} />
          }
          buttonOptions={[
            {
              type: 'primary',
              text: FOOTER?.EDIT_SAVE,
              clickEvent: (e) => {
                handleFooterClick(e, 'yes')
              },
              show: true,
              id: 'edit-bill-save'
            },
            {
              type: 'secondary',
              text: FOOTER?.EDIT_CANCEL,
              clickEvent: (e) => {
                handleFooterClick(e, 'no')
              },
              show: true,
              id: 'edit-bill-cancel'
            },
            {
              type: 'text',
              text: FOOTER?.EDIT_DELETE,
              clickEvent: (e) => {
                handleFooterClick(e, 'cancel')
              },
              id: 'remove',
              show: !isScheduled && !isAutopayment,
              isDangerousAction: true
            }
          ]}
        >
          {isTuxApp() && <MobileBillPayLayout />}
          {/* {!(loading || deleteLoading || isSystemError || deleteError) && ( */}
          <>
            <EditHeader
              {...{
                isFieldsValidationError,
                pageErrorMsg,
                payee,
                billerLogoUrl,
                isPayeeInternal
              }}
            />

            <EditDetails
              {...{
                name,
                setName,
                companyRef,
                personNameRef,
                companyErrorCount,
                personNameErrorCount,
                phoneNumberRef,
                accountNumberRef,
                addressCollectionRef,
                nickName,
                setNickName,
                payee,
                billerLogoUrl,
                isHideAccountNumber: isEbill,
                formValues,
                handleStatusUpdate,
                phoneNumberErrorCount,
                addressCollectionErrorCount,
                googleAPIkey,
                fieldLevelErrorData,
                isPayeeCategoryBusiness: isManagedBiller,
                isScheduled,
                isAutopayment,
                handleFooterClick,
                modifiableFields: aggregateBillPayee?.modifiableFields,
                isPersonBiller
              }}
            />

            {openModal && (
              <RemoveBillPopup
                openModal={openModal}
                closePopup={closePopup}
                removeBill={removeBill}
                displayName={
                  billPayPayee?.displayName || billPayPayee?.nickName
                }
              />
            )}
          </>
        </PageFooterWrapper>
      )}
      {(isSystemError || deleteError) && <ErrorComponent />}
    </div>
  )
}

export default Edit
